module.exports = __webpack_public_path__ + "img/data-services.aee4f30a.svg";